import { loadable } from 'utils';

export const Edit = loadable(() => import('./Edit'), {});
